module.exports = __webpack_public_path__ + "img/1554793932.5ee412a7.jpg";